import flatMap from "lodash/flatMap";
/**
 * Extract all doc tree leaf nodes flattened as an array.
 */
export const getDocLeaves = (doc) => {
    var _a, _b;
    if (!doc || !doc.type || (doc.type === "doc" && !((_a = doc.content) === null || _a === void 0 ? void 0 : _a.length))) {
        return [];
    }
    if (!((_b = doc.content) === null || _b === void 0 ? void 0 : _b.length)) {
        return [doc];
    }
    return flatMap(doc.content, getDocLeaves);
};
/**
 * Get all non empty textual nodes from the doc.
 */
export const getDocTextualNodes = (doc) => {
    const leaves = getDocLeaves(doc);
    return leaves
        .filter((node) => node.type === "text" && !!node.text)
        .map((node) => node.text);
};
/**
 * Extract the textual length of a `doc`.
 */
export const getTextualLength = (doc) => {
    var _a;
    return (_a = getDocTextualNodes(doc).join("").length) !== null && _a !== void 0 ? _a : 0;
};
